import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Instagram, Youtube } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const locations = ['West Leeds', 'North Leeds', 'York', 'Hull', 'Durham', 'Derby', 'Rotherham', 'Normanton', 'Lincoln', 'West London', 'Athens'];

  return (
    <footer className="bg-uf-black border-t border-uf-border" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <Logo size="sm" />
            <p className="text-uf-textMuted mt-4 text-sm leading-relaxed">
              Building legacies since 2015. Premium fitness facilities across the UK and Greece.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.facebook.com/UltraFlexGyms" target="_blank" rel="noopener noreferrer" className="text-uf-textMuted hover:text-uf-red transition-colors"><Facebook size={20} /></a>
              <a href="https://www.instagram.com/ultraflexgyms" target="_blank" rel="noopener noreferrer" className="text-uf-textMuted hover:text-uf-red transition-colors"><Instagram size={20} /></a>
              <a href="https://www.youtube.com/channel/UCIAR2QqxmCILBFLoHIIAPvA" target="_blank" rel="noopener noreferrer" className="text-uf-textMuted hover:text-uf-red transition-colors"><Youtube size={20} /></a>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-4">Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/locations" className="footer-link">Locations</Link>
              <Link to="/membership" className="footer-link">Membership</Link>
              <Link to="/shop" className="footer-link">Shop</Link>
              <Link to="/book-tour" className="footer-link">Book a Tour</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </div>
          </div>
          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-4">Locations</h4>
            <div className="grid grid-cols-2 gap-2">
              {locations.map(loc => (
                <Link key={loc} to="/locations" className="footer-link text-xs">{loc}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-heading text-xl font-bold text-white mb-4">Contact</h4>
            <div className="flex flex-col gap-3 text-sm text-uf-textMuted">
              <a href="mailto:info@ultraflexgym.co.uk" className="hover:text-uf-red transition-colors flex items-center gap-2">
                <Mail size={16} /> info@ultraflexgym.co.uk
              </a>
              <a href="mailto:memberships@ultraflexgym.co.uk" className="hover:text-uf-red transition-colors flex items-center gap-2">
                <Mail size={16} /> Membership Enquiries
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-uf-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-uf-textMuted text-xs">&copy; {new Date().getFullYear()} UltraFlex Gym. All rights reserved.</p>
          <p className="text-uf-textMuted text-xs">Minimum age 16 to train alone. 14-16 year olds must be accompanied by a paying adult.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
